module.exports = {
  siteTitle: 'CHRISTIAN EFFIONG | Software Developer', // <title>
  manifestName: 'Christian Effiong',
  manifestShortName: 'Christian', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#181818f2',
  manifestThemeColor: '#181818f2',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/favicon.png',
  pathPrefix: `/gatsby-starter-solidstate/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Christian Effiong',
  subHeading: 'Software Developer. Technical Writer. Tech Volunteer',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/krizten',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/__krizten',
    },
    {
      icon: 'fa-linkedin',
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/christianeffiong',
    },
  ],
  phone: '+234-••••••••••',
  address: 'Lagos, Nigeria',
  email: 'mailstochristian@gmail.com'
};
